import gql from "graphql-tag";


export const ListEvents = gql`
  query Events {
    listEvents {
      value: id
      text: title
      type
    }
  }
`;

export const ListCompetitions = gql`
  query Competitions($eventId: String!) {
    listEventCompetitions(eventId: $eventId) {
      value: competitionId
      text: i18n_title
    }
  }
`;

export const ListTeams = gql`
  query Teams($competitionId: String!) {
    listRegisteredTeams(competitionId: $competitionId) {
      items {
        teamId
        name
        robotName
        mentor
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/private/user/containers/Competitors/graphql.js